<template>
  <div class="gateway-list">
    <!-- VM List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      @click="pushDetail"
      detailUrl="/networking/gateways"
      :moduleName="`gateways.gateways`"
      :moduleCreateEvent="`subHeaderDetailOpen`"
      :moduleSearch="search"
    >
      <template v-slot:item.type="{ item }">
        <!-- <i :class="`icon fas fa-server`"></i> -->

        <img
          src="/image/netgatewaylogo.png"
          :alt="item.type"
          :title="item.type"
          class="typeImage"
          v-if="item.type == 'plusclouds-netgateway'"
        />
        <div v-else>{{ item.type }}</div>
      </template>

      <template v-slot:item.status="{ item }">
        <Label :class="item.status.toLowerCase()">{{
          $capitalize(item.status)
        }}</Label>
      </template>

      <template v-slot:item.is_locked="{ item }">
        <LockButton
          icon="fas fa-lock"
          class="danger"
          v-if="item.is_locked"
        ></LockButton>
        <LockButton icon="fas fa-unlock" class="primary" v-else></LockButton>
      </template>

      <template v-slot:item.action="{ item }">
        <!-- <ActionButton icon="fas fa-pencil"
                      :title="$t('global.update')"
                      @click.native="openForUpdate(item)"></ActionButton> -->
        <ActionButton
          icon="fas fa-eye"
          :title="$t('global.openDetail')"
          @click.native="pushDetail(item)"
        ></ActionButton>
        <DeleteButton
          icon="fad fa-trash"
          :title="$t('global.delete')"
          @click.native="openDeleteHandler(item)"
        ></DeleteButton>
      </template>
    </List>

    <!-- Create VM Popup -->
    <DetailModal
      :title="
        $t(
          selectedItem == ''
            ? 'gateways.createNewGateway'
            : 'gateways.updateGateway'
        )
      "
      :show="showDetail"
      @confirm="confirmModal()"
      @closeDetail="closeDetail()"
      :resetForm="resetForm"
    >
      <CreateGateway
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
        :selectedItem="selectedItem"
      />
    </DetailModal>

    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service'
// Utils
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'

export default {
  name: 'Gateways',
  data() {
    return {
      search: '',
      showDetail: false,
      loading: false,
      confirmCreate: false,
      resetForm: false,
      header: [
        {
          text: '',
          value: 'type',
          size: '100px',
          clicked: true,
        },
        {
          text: 'global.name',
          value: 'name',
          clicked: true,
        },
        { text: 'global.state', value: 'status' },
        { text: 'global.ipAddress', value: 'ip_addr', copyField: true },
        { text: 'global.connectedTo', value: 'managed_network' },
        { text: 'global.lock', value: 'is_locked' },
        { text: 'global.actions', value: 'action', size: '100px' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
      selectedItem: '',
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'gateways.gateways',
        route: '/networking/gateways',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'global.networking',
        },
        {
          title: 'gateways.gateways',
          route: '/networking/gateways',
        },
      ],
      searchPlaceholder: 'gateways.searchForGateway',
      detailPlaceholder: 'gateways.createNewGateway',
    })
    EventBus.$on(`subHeaderSearch`, this.listenersubHeaderSearch)
    EventBus.$on(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderSearch`, this.listenersubHeaderSearch)
    EventBus.$off(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  methods: {
    listenersubHeaderSearch(payload) {
      this.search = payload
      this.getList()
    },
    listenersubHeaderDetailOpen(payload) {
      this.selectedItem = ''
      this.showDetail = payload
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `packetbender/netgateways/overview?position=id|desc&page=${
        current_page ? current_page : 1
      }`

      if (this.search) $query += `&name=${this.search}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openDeleteHandler(item) {
      this.deleteOperationUrl = `packetbender/netgateways/${item.id}?delete_resources=1`
      this.$bvModal.show('modal-deleteOperation')
    },
    openForUpdate(item) {
      this.selectedItem = item
      this.showDetail = true
    },
    pushDetail(item) {
      this.$router.push('/networking/gateways/' + item.id)
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    closeDetail() {
      this.showDetail = false
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    CreateGateway: () => import('@/components/forms/CreateGateway'),
  },
}
</script>

<style lang="scss" scoped>
.gateway-list {
  .typeImage {
    max-width: 75px;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #00baf2;
    border: 1px solid rgba(181, 181, 195, 0.3);
    border-radius: 6px;
    padding: 6px;
  }
}
</style>
